import { render } from "./Location.vue?vue&type=template&id=2153717e"
import script from "./Location.vue?vue&type=script&lang=ts"
export * from "./Location.vue?vue&type=script&lang=ts"
script.render = render

export default script